import MentoringProgram from 'athena/components/mentoring-program';

/* @ngInject */
export default function MentoringProgramController(
  $scope,
) {
  $scope.MentoringProgram = MentoringProgram;
}
